import { AllowedLang } from '@/context/user-info';
import translationCa from './ca/translation.json';
import translationEn from './en/translation.json';
import translationEs from './es/translation.json';
import translationFr from './fr/translation.json';

export const locales: Record<AllowedLang, { translation: typeof translationFr }> = {
  ca: { translation: translationCa },
  en: { translation: translationEn },
  es: { translation: translationEs },
  fr: { translation: translationFr },
};
